import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';

import { WorkingHourProof } from '../working-hour-proof';

export class WorkingHourProofBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingHourProof(
        json.hash,
        json.userHash,
        json.userName,
        json.day,
        json.totalTime,
        json.editable,
        json.validated,
        json.proofHash,
        json.proofName,
        json.proofDescription,
        json.proofIsXPO,
        json.proofIsMED,
        json.proofIsCOA,
        json.proofIsOTR
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ? sortByString('proofName', mapCollection(WorkingHourProofBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-hour-proof.builder.ts